document.addEventListener("DOMContentLoaded", () => {
  if (customElements.get("p-sale-bundle-swiper")) return;

  class PSaleBundleSwiper extends HTMLElement {
    constructor() {
      super();
      this.$this = $(this);
      this.productInfo = {};
      this.selectedProduct = {};
      this.childSwiperInstances = [];
      this.discountRules = this.$this.data("discount-rules");
      this.childPcEnableSwiper = this.$this.data("child-pc-enable-swiper");
      this.childMbEnableSwiper = this.$this.data("child-mb-enable-swiper");
      this.childPcSlides = this.$this.data("child-pc-slides");
      this.childMbSlides = this.$this.data("child-mb-slides");
      this.childPcGap = this.$this.data("child-pc-gap");
      this.childMbGap = this.$this.data("child-mb-gap");
      this.childShowNavigation = this.$this.data("child-show-navigation");
      this.$groupSwiperContainer = this.$this.find(".p-sale-bundle-swiper-groups-container");
      this.$groupNamesWrapper = this.$this.find(".p-sale-bundle-swiper-groups-names-wrapper");

      this.handleGroupChange = this.handleGroupChange.bind(this);
    }

    connectedCallback() {
      this.initGroupSwiper();
      this.initChildSwiper();
      this.initProductInfo();
      this.initCheckboxEvent();
      let resizeTimer = null;
      const self = this;
      let lastWidth = window.innerWidth;
      $(window).on("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          const currentWidth = window.innerWidth;
          if (currentWidth === lastWidth) return;
          self.rebuildSwipers();
          lastWidth = currentWidth;
        }, 200);
      });
    }

    disconnectedCallback() {
      this.destroySwipers();
    }

    initGroupSwiper() {
      if (this.$groupNamesWrapper.length > 0 && this.$groupSwiperContainer.length > 0) {
        const params = {
          slidesPerView: 1,
          noSwipingClass: "p-sale-bundle-swiper-group-no-swiping",
          allowTouchMove: true,
          spaceBetween: 10,
        };
        this.groupSwiperInstance = new Swiper(this.$groupSwiperContainer[0], params);
        this.initGroupSwiperNameEvent();
      }
    }

    initGroupSwiperNameEvent() {
      if (this.$groupNamesWrapper.length > 0 && this.groupSwiperInstance) {
        const self = this;
        this.handleGroupChange(0);
        this.$groupNamesWrapper.on("click", ".p-sale-bundle-swiper-group-name", function () {
          const index = $(this).data("index");
          self.handleGroupChange(index);
        });
      }
    }

    initChildSwiper() {
      const enableSwiper = window.innerWidth > 850 ? this.childPcEnableSwiper : this.childMbEnableSwiper;
      const $container = this.$this.find(".p-sale-bundle-swiper-children-container");
      const $wrapper = $container.find(".p-sale-bundle-swiper-children-wrapper");
      const $item = $wrapper.find(".p-sale-bundle-swiper-children-product-item");
      if (enableSwiper) {
        $container.addClass("swiper-container");
        $wrapper.addClass("swiper-wrapper");
        $item.addClass("swiper-slide");
        $container.each((i, childrenContainer) => {
          const params =
            window.innerWidth > 850
              ? {
                  slidesPerView: this.childPcSlides,
                  spaceBetween: this.childPcGap,
                  allowTouchMove: this.childPcSlides < $item.length,
                }
              : {
                  slidesPerView: this.childMbSlides,
                  spaceBetween: this.childMbGap,
                  allowTouchMove: this.childMbSlides < $item.length,
                };
          if (window.innerWidth < 850) {
            const offsetValue = this.getSwiperOffset();
            params.slidesOffsetBefore = offsetValue;
            params.slidesOffsetAfter = offsetValue;
          }
          if (this.childShowNavigation && params.allowTouchMove) {
            const $buttons = $(childrenContainer).parent().find(".p-sale-bundle-swiper-buttons-container");
            params.navigation = {
              nextEl: $buttons.find(".swiper-button-next")[0],
              prevEl: $buttons.find(".swiper-button-prev")[0],
            };
          }
          this.childSwiperInstances[i] = new Swiper(childrenContainer, params);
        });
      } else {
        $container.removeClass("swiper-container");
        $wrapper.removeClass("swiper-wrapper");
        $item.removeClass("swiper-slide");
      }
    }

    initProductInfo() {
      this.$this.find(".p-sale-bundle-swiper-group-container").each((_, group) => {
        try {
          const $group = $(group);
          const groupName = $group.data("group-name");
          this.productInfo[groupName] = {};
          const $childProduct = $group.find(".p-sale-product-card");
          $childProduct.each((productIndex, product) => {
            const productInfo = $(product).data("product-info");
            //每组默认选中前三个
            if (productIndex < 3) {
              const key = this.parseKey({
                groupName,
                product: productInfo.product,
                variantId: productInfo.variants[0].variantId,
              });
              this.toggleProductSelect(
                key,
                productInfo.variants[0],
                $childProduct.find(".p-sale-bundle-swiper-checkbox").eq(productIndex),
              );
            }
            if (productInfo.product) {
              this.productInfo[groupName][productInfo.product] = productInfo;
            }
          });
        } catch (e) {
          console.error(">>> p-sale-bundle-swiper", e);
        }
      });
      this.updatePrice();
      this.updateButtons();
    }

    initCheckboxEvent() {
      this.addEventListener("click", (e) => {
        const $checkbox = $(e.target).closest(".p-sale-bundle-swiper-checkbox");
        if ($checkbox.length > 0) {
          const $productCard = $checkbox.closest(".p-sale-product-card");
          const $group = $checkbox.closest(".p-sale-bundle-swiper-group-container");
          const info = $productCard.data("product-info");
          const groupName = $group.data("group-name");
          const key = this.parseKey({ groupName, product: info.product, variantId: info.variants[0].variantId });
          this.toggleProductSelect(key, info.variants[0], $checkbox);
          this.updatePrice();
          this.updateButtons();
        }
      });
    }

    toggleProductSelect(key, variant, $checkbox) {
      if (this.selectedProduct[key]) {
        delete this.selectedProduct[key];
        $checkbox.removeClass("is-active");
        $checkbox.attr('aria-checked', 'false');
      } else {
        $checkbox.addClass("is-active");
        $checkbox.attr('aria-checked', 'true');
        this.selectedProduct[key] = variant;
      }
    }

    updatePrice() {
      const result = {};
      Object.keys(this.selectedProduct).forEach((key) => {
        const variant = this.selectedProduct[key];
        const [groupName, product, variantId] = this.parseKey(key);
        if (!result[groupName]) {
          result[groupName] = {
            total: 0,
            compare: 0,
            variantId: [],
            count: 0,
          };
        }
        result[groupName].total += variant.price;
        result[groupName].compare += variant.compareAtPrice;
        result[groupName].variantId.push(variantId);
        result[groupName].count += 1;
      });
      this.$this.find(".p-sale-bundle-swiper-group-container").each((_, group) => {
        const $group = $(group);
        const groupName = $group.data("group-name");
        const $priceEl = $group.find(".p-sale-bundle-swiper-price-total");
        const $compareEl = $group.find(".p-sale-bundle-swiper-price-compare-at");
        const $discountEl = $group.find(".p-sale-bundle-swiper-price-discount");
        let total = 0;
        let compare = 0;
        if (result[groupName]) {
          total = result[groupName].total;
          compare = result[groupName].compare;
        }

        const calcTotal = this.getCalculatedPrice(total, result[groupName]?.count);

        const totalFormat = window.theme?.Currency?.formatMoney(calcTotal, window.theme?.strings?.moneyFormat);

        const compareFormat = window.theme?.Currency?.formatMoney(compare, window.theme?.strings?.moneyFormat);

        const discount = window.theme?.Currency?.formatMoney(compare - calcTotal, window.theme?.strings?.moneyFormat);
        $priceEl.text(totalFormat);
        $compareEl.text(compareFormat);
        $discountEl.text(discount);
      });
    }

    getCalculatedPrice(price, count = 0) {
      const str = this.discountRules;
      if (!str || !count || !price) return price;

      const rules = str
        .split(",")
        .map((rule) => {
          const [qtyPart, discountPart] = rule.split(":");
          if (!qtyPart || !discountPart) return null;

          let min, max;

          if (qtyPart.includes("+")) {
            min = parseInt(qtyPart);
            max = Infinity;
          } else if (qtyPart.includes("-")) {
            const [minStr, maxStr] = qtyPart.split("-");
            min = parseInt(minStr);
            max = parseInt(maxStr);
          } else {
            min = parseInt(qtyPart);
            max = min;
          }

          return {
            min,
            max,
            discount: parseFloat(discountPart),
          };
        })
        .filter(Boolean)
        .sort((a, b) => a.min - b.min);

      let discount = 1;

      for (const rule of rules) {
        if (count >= rule.min && count <= rule.max) {
          discount = rule.discount;
        }
      }

      return price * discount;
    }

    updateButtons() {
      const result = {};
      Object.keys(this.selectedProduct).forEach((key) => {
        const [groupName, product, variantId] = this.parseKey(key);
        if (!result[groupName]) {
          result[groupName] = [];
        }
        result[groupName].push(variantId);
      });
      this.$this.find(".p-sale-bundle-swiper-group-container").each((_, group) => {
        const $group = $(group);
        const groupName = $group.data("group-name");
        const $buyNowButton = $group.find(".p-sale-bundle-swiper-buy-now");
        const $addToCart = $group.find(".p-sale-bundle-swiper-add-to-cart");
        $buyNowButton.attr("data-id", result[groupName]?.join(",") || "");
        $addToCart.attr(
          "data-products",
          JSON.stringify(
            (result[groupName] || []).map((id) => {
              return { variantId: id, quantity: 1 };
            }),
          ),
        );
      });
    }

    parseKey(param) {
      if (typeof param === "object") {
        const { groupName, product, variantId } = param;
        return `${groupName}::${product}::${variantId}`;
      } else if (typeof param === "string") {
        const [groupName, product, variantId] = param.split("::");
        return [groupName, product, variantId];
      }
    }

    destroySwipers() {
      if (this.groupSwiperInstance && !this.groupSwiperInstance.destroyed) {
        this.groupSwiperInstance.off("slideChange.fixed");
        this.groupSwiperInstance.destroy(true, true);
        this.groupSwiperInstance = null;
      }
      if (Array.isArray(this.childSwiperInstances) && this.childSwiperInstances.length > 0) {
        this.childSwiperInstances.forEach((instance) => {
          instance.off("slideChange.fixed");
          instance.destroy(true, true);
          instance = null;
        });
        this.childSwiperInstances = [];
      }
    }

    rebuildSwipers() {
      this.destroySwipers();
      this.initGroupSwiper();
      this.initChildSwiper();
    }

    handleGroupChange(index) {
      this.groupSwiperInstance.slideTo(index);

      const $items = this.$groupNamesWrapper.find(".p-sale-bundle-swiper-group-name");
      const $active = $items.removeClass("is-active").eq(index).addClass("is-active");

      const container = this.$groupNamesWrapper.parent()[0]; // container
      const item = $active[0];

      if (!container || !item) return;

      const containerWidth = container.clientWidth;
      const itemLeft = item.offsetLeft;
      const itemWidth = item.offsetWidth;

      const target = itemLeft - containerWidth / 2 + itemWidth / 2;

      const maxScroll = container.scrollWidth - containerWidth;
      const finalScroll = Math.max(0, Math.min(target, maxScroll));

      container.scrollTo({
        left: finalScroll,
        behavior: "smooth",
      });
    }

    getSwiperOffset() {
      const cssOffset = getComputedStyle(document.documentElement)
        .getPropertyValue("--p-common-wrapper-half-padding")
        .trim();
      const el = document.createElement("div");
      el.style.position = "absolute";
      el.style.visibility = "hidden";
      el.style.pointerEvents = "none";
      el.style.width = `${cssOffset}`;

      document.body.appendChild(el);
      const value = el.getBoundingClientRect().width;
      document.body.removeChild(el);

      return value;
    }
  }

  customElements.define("p-sale-bundle-swiper", PSaleBundleSwiper);
});
